import React from 'react'
import { userLogout } from '../../API/api'

export default function SSOError() {
  return (
    <>
      <div className="container text-center">
    <div className="row">
      <div className="col-md-12" style={{marginTop: '50px'}}>
        <h3>Thanks for trying to access Vizerto!</h3>
        <br/>
        <p style={{fontSize:"16px"}}>We have notified Vizerto admin to grant you an access.
          <br />Please try logging in after you receive confirmation email from Vizerto.</p>
        <br/>
        <p style={{fontSize:"15px"}}>If its any consolation, we can take you to your <a onClick={()=>userLogout()}>Okta home page.</a></p>
      </div>
    </div>
  </div>
    </>
  )
}
